var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"bottom-txt"},[_c('div',{staticClass:"extra-info",domProps:{"innerHTML":_vm._s(_vm.category.description)}})])}
var staticRenderFns = []

export { render, staticRenderFns }